import React from 'react';
import './css/MainFooter.css';
import { HashLink as Link } from "react-router-hash-link";
import { FiInstagram, FiLinkedin } from "react-icons/fi";
import { useLocation } from 'react-router-dom';
import VoicesFooter from '../voices/VoicesFooter';
import { isVoicesRoute } from '../voices/voicesRoutes';

export default function MainFooter() {
    const { pathname } = useLocation();
    return isVoicesRoute(pathname) ? <VoicesFooter /> : <LegacyFooter />;
}

function LegacyFooter() {

    const servicesData = [
        {
            id: 1,
            category: "Salesforce",
            icon: "ri-cloud-line",
            subcategories: [
                { id: 1, name: "Salesforce Health Cloud" },
                { id: 2, name: "Salesforce Data Cloud" },
                { id: 3, name: "Salesforce Revenue Cloud (CPQ)" },
                { id: 4, name: "Salesforce Agentforce" },
                { id: 5, name: "Salesforce Marketing Cloud" },
                { id: 6, name: "Salesforce Field Service" },
                { id: 7, name: "Salesforce Experience Cloud" },
                { id: 8, name: "Salesforce Service Cloud" },
                { id: 9, name: "Salesforce Implementation" }
            ]
        },
        {
            id: 2,
            category: "Integration",
            icon: "ri-links-line",
            subcategories: [
                { id: 10, name: "MuleSoft" },
                { id: 11, name: "Celigo" },
                { id: 12, name: "QuickBooks" },
                { id: 13, name: "NetSuite" },
                { id: 14, name: "DocuSign" },
                { id: 15, name: "Zapier" },
                { id: 16, name: "Twilio" },
                { id: 17, name: "Stripe" },
                { id: 18, name: "Slack" }
            ]
        },
        {
            id: 3,
            category: "Marketing Automation",
            icon: "ri-bar-chart-box-line",
            subcategories: [
                { id: 19, name: "Salesforce Marketing Cloud Next" },
                { id: 20, name: "Salesforce Marketing Cloud Advanced" },
                { id: 21, name: "HubSpot Implementation" },
                { id: 22, name: "Braze" }
            ]
        },
        {
            id: 4,
            category: "Strategy & Advisory",
            icon: "ri-bar-chart-box-line",
            subcategories: [
                { id: 23, name: "Digital Transformation" },
                { id: 24, name: "Platform Migration" },
                { id: 25, name: "Technology Revamp" },
                { id: 26, name: "Data Governance and Security" }
            ]
        },
        {
            id: 5,
            category: "Snowflake",
            icon: "ri-bar-chart-box-line",
            subcategories: [
                { id: 27, name: "Snowflake Implementation & Migration" },
                { id: 28, name: "Data Engineering & Pipelines" },
                { id: 29, name: "Data Warehousing & BI Enablement" }
            ]
        },
        {
            id: 6,
            category: "DevOps",
            icon: "ri-bar-chart-box-line",
            subcategories: [
                { id: 30, name: "AWS" },
                { id: 31, name: "Copado" },
                { id: 32, name: "Gearset" },
                { id: 33, name: "Azure" }
            ]
        },
        {
            id: 7,
            category: "AI",
            icon: "ri-bar-chart-box-line",
            subcategories: [
                { id: 34, name: "Chat Agents" },
                { id: 35, name: "Voice Agents" },
                { id: 36, name: "Sales Agents (sentiment)" },
                { id: 37, name: "AI Service Agents" }
            ]
        },
        {
            id: 8,
            category: "Design",
            icon: "ri-bar-chart-box-line",
            subcategories: [
                { id: 38, name: "Prototyping & Wireframing" },
                { id: 39, name: "User Experience" },
                { id: 40, name: "Design Thinking" }
            ]
        },
        {
            id: 9,
            category: "Healthcare Solutions",
            icon: "ri-megaphone-line",
            subcategories: [
                { id: 41, name: "EDI Processor" },
                { id: 42, name: "FHIR & HL7 Integration" }
            ]
        },
        {
            id: 10,
            category: "Others",
            icon: "ri-bar-chart-box-line",
            subcategories: [
                { id: 43, name: "MS Dynamics" },
                { id: 44, name: "ServiceNow" },
                { id: 45, name: "Zoho" }
            ]
        }
    ];
    const toSlug = (str) =>
        str
            .toLowerCase()
            .trim()
            .replace(/&/g, 'and')              // optional: & → and
            .replace(/[^a-z0-9\s-]/g, '')      // remove special characters
            .replace(/\s+/g, '-')              // spaces → hyphen
            .replace(/-+/g, '-');
    return (
        <div style={{ backgroundColor: '#1012a2' }}>
            <div className='container'>
                <footer>
                    {/* 5-column services grid */}
                    <div className="footer-logo-row">
                        <div className="footer-logo">
                            <Link to="/" className="logo-no-hover-link">
                                <img
                                    src="https://backendtestinternal.s3.amazonaws.com/antrazal_white.png"
                                    alt="Antrazal Logo" loading="lazy"
                                />
                            </Link>
                        </div>
                    </div>
                    <div className="footer-services-grid">
                        {
                            servicesData?.map((category) => (
                                <div className="footer-options" key={category.id}>
                                    <h4>{category.category}</h4>

                                    <ul>
                                        {category.subcategories.map((item) => (
                                            <li key={item.id}>
                                                <Link
                                                    to={`/services/${toSlug(item.name)}`}
                                                >
                                                    {item.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))
                        }
                    </div>

                    {/* Logo row */}


                    {/* Copyright bar */}

                </footer>
            </div>

            <div style={
                {
                    borderTop: '1px solid #3638d0'
                }
            }>
                <div className='container'>
                    <div className="footer-copyright">
                        <div className="footer-svg-icons">
                            <a href="https://in.linkedin.com/company/antrazal-solutions-private-limited" aria-label="Antrazal on LinkedIn" style={{ color: "#fff" }}>
                                <FiLinkedin aria-hidden="true" />
                            </a>
                            <a href="https://www.instagram.com/antrazal?igsh=MjZrY2l3NWw5b3g1" aria-label="Antrazal on Instagram" style={{ color: "#fff" }}>
                                <FiInstagram aria-hidden="true" />
                            </a>
                        </div>
                        <p style={{ color: "#fff", fontWeight: "300" }}>©2025 Antrazal. ALL RIGHTS RESERVED</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
